export const mountGoogleTag = (
  tagId,
  analyticsDomain = 'www.googletagmanager.com'
) => {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    if (!w[l].some(item => item['gtm.start'])) {
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
    }
    const f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = `https://${analyticsDomain}/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', tagId);
};
